export default import.meta.ROLLDOWN_FILE_URL_SISXVfOHzvrvEjI0CfgJog